import { Reducer } from 'redux';

import { Action, ActionType } from '../actionTypes/reportConfirmActionType';
import { IConfirmedReport, IIsCoordinatorConfirmedReport as IsCoordinatorConfirmedReport } from '../../models/reportConfirm';

export interface IIsCoordinatorConfirmedReportState {
    isCoordinatorConfirmedReport: IsCoordinatorConfirmedReport;
    confirmedReports: IConfirmedReport[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    isCoordinatorConfirmedReport: 
    {
        userconfirmer: '',
        user_c: false,
        userconfirmshamsidate: '',
    },
    confirmedReports: [],
    loading: false,
    error: '',
};
export const CoordinatorConfirmedReportReducer: Reducer<IIsCoordinatorConfirmedReportState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_COORDINATORCONFIRM:
        case ActionType.FETCH_CONFIRMREPORTS:        
        case ActionType.EDIT_COORDINATORCONFIRM:
            return { ...state, loading: true };

        case ActionType.FETCH_COORDINATORCONFIRM_FAIL:
        case ActionType.FETCH_CONFIRMREPORTS_FAIL:        
        case ActionType.EDIT_COORDINATORCONFIRM_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.FETCH_COORDINATORCONFIRM_SUCCESS:
            // console.log('action.payload: ', action.payload.data)
            return {
                ...state,
                isCoordinatorConfirmedReport: action.payload.data,
                loading: false
            };
            //[ ...state.projectInfos, ..._.mapKeys(action.payload, 'id')]

        case ActionType.FETCH_CONFIRMREPORTS_SUCCESS:
            console.log('action.payload: ', action.payload.data)
            return {
                ...state,
                confirmedReports: action.payload.data,
                loading: false
            };
            //[ ...state.projectInfos, ..._.mapKeys(action.payload, 'id')]
            
        case ActionType.EDIT_COORDINATORCONFIRM_SUCCESS:
            return {
                ...state,
                isCoordinatorConfirmedReport: action.payload.data,
                loading: false
            };
        default:
            return state;
    }
};
